import { render, staticRenderFns } from "./DashboardLaundryPendingOrders.vue?vue&type=template&id=e07bb90e&scoped=true"
import script from "./DashboardLaundryPendingOrders.vue?vue&type=script&lang=js"
export * from "./DashboardLaundryPendingOrders.vue?vue&type=script&lang=js"
import style0 from "./DashboardLaundryPendingOrders.vue?vue&type=style&index=0&id=e07bb90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07bb90e",
  null
  
)

export default component.exports